import mock1 from './mock1';
import mock2 from './mock2';
import mock3 from './mock3';
import mock4 from './mock4';
import mock5 from './mock5';
import mapMock1 from './mapMock1';

export const SINGLE_SERIE = 'Single serie';
export const TWO_SERIES = 'Two series';
export const SMALL_SINGLE_SERIE = 'Small single serie';
export const MANY_SERIES = 'Many series';
export const TRADE_SERIES = 'Trade series';

export const MOCKS_LIST = [
  { name: SINGLE_SERIE, data: mock1 },
  { name: TWO_SERIES, data: mock2 },
  { name: SMALL_SINGLE_SERIE, data: mock3 },
  { name: MANY_SERIES, data: mock4 },
  { name: TRADE_SERIES, data: mock5 },
];

export const DATA_MOCKS_LIST = {
  [SINGLE_SERIE]: mock1,
  [TWO_SERIES]: mock2,
  [SMALL_SINGLE_SERIE]: mock3,
  [MANY_SERIES]: mock4,
};

export const US_STATES = 'US states';

export const MAP_MOCK_LIST = {
  [US_STATES]: mapMock1,
};
